import { defineWave } from '../schema';

/** BLOC G1 — LA CRÊTE. Densité maximale de la campagne.
 *
 *  Le seul bloc du jeu où les six natures de menace coexistent : trajectoire
 *  imposée (Tisseur), zone interdite (Mortier), poursuite (Faucheur),
 *  géographie statique (Rôdeur), pression corporelle (Dard), et cible qu'il
 *  faut contourner ou démonter (Égide, Bastion).
 *
 *  ── Pourquoi ça reste jouable ──
 *  Parce que rien n'y est nouveau. Un pic de difficulté n'a le droit d'être un
 *  pic de DENSITÉ que s'il n'est pas aussi un pic de nouveauté : le joueur doit
 *  pouvoir tout reconnaître à l'instant où il le voit, et n'avoir à gérer que
 *  la simultanéité. Introduire ici le moindre comportement inédit
 *  transformerait un examen en piège.
 *
 *  ── Ce qu'il mesure ──
 *  La capacité à IGNORER. Il y a plus de cibles que de temps pour les abattre,
 *  et la plupart n'ont pas besoin de mourir — un Bastion finit par sortir du
 *  cadre, une Égide contournée cesse de compter. Le joueur qui essaie de tout
 *  détruire se fait déborder ; celui qui trie s'en sort avec de la marge.
 *
 *  ⚠️ Ignorer n'est pas la même chose que subir. Depuis que les corps ennemis
 *  blessent au contact, un Bastion laissé en vie descend en occupant du
 *  terrain : le joueur ne l'oublie pas, il choisit de lui céder la place. C'est
 *  un arbitrage plus riche qu'auparavant — et plus exigeant, puisque le prix de
 *  l'inaction est désormais spatial et non seulement temporel.
 *
 *  C'est la dernière chose que le monde 3 enseigne avant le Colosse, et c'est
 *  précisément ce que le Colosse demandera : décider de ce qu'on ne fait pas.
 *
 *  ⚠️ Dernier Mortier à 12 s. Il reste posé une vingtaine de secondes et le
 *  bloc en dure 26 : plus tard, il survivrait au bloc et se retrouverait actif
 *  pendant le rappel puis le silence d'avant-boss. */
export default defineWave({
  id: 'g1-crete',
  duration: 26,
  spawns: [
    { at: 0.5, enemy: 'tisseur', lane: 2, count: 1, spacing: 0 },
    { at: 1.0, enemy: 'egide', lane: 4, count: 1, spacing: 0 },
    { at: 3.5, enemy: 'dard', lane: 3, count: 3, spacing: 0.45 },
    { at: 6.0, enemy: 'bastion', lane: 3, count: 1, spacing: 0 },
    { at: 8.0, enemy: 'mite', lane: 1, count: 8, spacing: 0.07 },
    { at: 10.0, enemy: 'rodeur', lane: 5, count: 1, spacing: 0 },
    { at: 12.0, enemy: 'mortier', lane: 2, count: 1, spacing: 0 },
    { at: 14.0, enemy: 'tisseur', lane: 4, count: 1, spacing: 0 },
    { at: 16.0, enemy: 'dard', lane: 1, count: 3, spacing: 0.4 },
    { at: 16.4, enemy: 'dard', lane: 5, count: 3, spacing: 0.4 },
    { at: 18.0, enemy: 'faucheur', lane: 3, count: 2, spacing: 1.1 },
    { at: 21.0, enemy: 'eclat', lane: 2, count: 3, spacing: 0.45 },
    { at: 21.4, enemy: 'eclat', lane: 4, count: 3, spacing: 0.45 },
    { at: 23.5, enemy: 'mite', lane: 3, count: 10, spacing: 0.06 },
  ],
});
